import { Constants, WebFormMode } from '@dx-ui/dx-common';
import { useEffect, useMemo, useState } from 'react';
import {
  Loading,
  linkToRecord,
  useDataProvider,
  useNotify,
  useRedirect,
} from 'react-admin';
import { useRouteMatch } from 'react-router-dom';
import {
  DespatchAdviceService,
  DespatchAdviceServiceCreator,
  DocumentServiceFactory,
} from '../../services';

const DespatchAdviceCreate = (props) => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const notify = useNotify();

  const [data, setData] = useState<any>(undefined);
  const [loading, setLoading] = useState(false);

  const match: any = useRouteMatch();
  const { recipientId } = match.params;

  const despatchAdviceService: DespatchAdviceService = useMemo(
    () =>
      DocumentServiceFactory.create(
        DespatchAdviceServiceCreator,
        dataProvider
      ) as DespatchAdviceService,
    [dataProvider]
  );

  useEffect(() => {
    const createNewDespatchAdvice = async () => {
      setLoading(true);
      try {
        const nodeId: string | undefined =
          await despatchAdviceService.createNew(recipientId);

        setData(nodeId);
        setLoading(false);
        redirect(
          `/${linkToRecord(Constants.RESOURCE_WEBDESPATCH_ADVICE, nodeId)}`,
          undefined, // basePath
          undefined, // id
          undefined, // data
          { redirectMode: WebFormMode.SCRATCH_DESPATCH_ADVICE } // state
        );
      } catch (e) {
        notify(
          'dxMessages.dashboard.OnErrorContactSupport',
          'error',
          { error: e },
          true
        );
        setLoading(false);
      }
    };
    if (!data) {
      createNewDespatchAdvice();
    }
  }, [data, despatchAdviceService, notify, recipientId, redirect]);
  if (loading) {
    return <Loading />;
  } else return null;
};

export default DespatchAdviceCreate;
